//#region ng
import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  signal
} from "@angular/core";
//#endregion

//#region models
import { PAG_ITENS_POR_PAG } from "../../../_misc/_models/consts";
//#endregion

//#region services
import { CorStorageService } from "../../../_ng/_services";
//#endregion

@Component({
  selector: "cor-bs-pag-sel-offset",
  templateUrl: "pag-sel-offset.component.html",
  styleUrls: ["pag-sel-offset.component.scss"]
})
export class CorBsPagSelOffsetComponent {
  //#region inputs
  @Input() max: any = 0;
  // storageKey
  #storageKey: string;
  get storageKey(): string { return this.#storageKey; }
  @Input() set storageKey(val: string) {
    this.#storageKey = val;
    this.offsetSel = this.#storageServ.ls_get(val) || '12';
  }
  //#endregion

  //#region outputs
  @Output() change$ = new EventEmitter<string>();
  //#endregion

  //#region publics
  itensPorPag = signal<number[]>([]);
  //#endregion

  //#region offsetSel
  #offsetSel: string;
  get offsetSel(): string { return this.#offsetSel; }
  set offsetSel(val: string) {
    // console.log(val);    
    this.#offsetSel = val;
    this.storageKey && this.#storageServ.ls_set(this.storageKey, val);
    this.change$.emit(val);
  }
  //#endregion

  //#region injects
  #storageServ = inject(CorStorageService);
  //#endregion

  //#region lifecycles
  ngOnInit() {
    const MAX: number = parseInt(this.max) || 0;
    this.itensPorPag.set(PAG_ITENS_POR_PAG.filter((i: number) => MAX === 0 || i <= MAX));
    // this.offsetSel = this.offset;
  }
  //#endregion

  //#region functions
  tidn(index: any, item: number): number { return item || 0; }
  //#endregion
}
